import { render, staticRenderFns } from "./ResourcesItem.vue?vue&type=template&id=5ff9158c&scoped=true"
import script from "./ResourcesItem.vue?vue&type=script&lang=js"
export * from "./ResourcesItem.vue?vue&type=script&lang=js"
import style0 from "./ResourcesItem.vue?vue&type=style&index=0&id=5ff9158c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff9158c",
  null
  
)

export default component.exports